module.exports = __webpack_public_path__ + "img/64597f9.jpg";